import { LogoLoader } from '@components/UIKit/LogoLoader/LogoLoader';
import { EmptyList } from '@components/UIKit/EmptyList/EmptyList';
import { Pagination } from '@components/UIKit/Pagination/Pagination';
import { Page } from './ArtistPage';
import s from '../grid.module.scss';
interface PaginatedArtistGridProps<T> {
  data?: {
    items: T[];
    totalPages: number;
  };
  children: (props: T) => React.ReactNode;
  currentPage: number;
  onPageChange: (page: number) => void;
  status: 'error' | 'loading' | 'success';
  EmptyComponent?: () => JSX.Element;
  listClassName?: string;
  showBanners?: boolean;
  skipFirstBanner?: boolean;
  limit: number;
}
export const PaginatedArtistGrid = <T extends Record<'id', number>,>({
  data,
  children,
  currentPage,
  onPageChange,
  status,
  EmptyComponent,
  listClassName,
  showBanners = false,
  skipFirstBanner = false,
  limit
}: PaginatedArtistGridProps<T>) => {
  if (status === 'loading') {
    return <div className={s.gridWrapper}>
                <LogoLoader />
            </div>;
  }
  if (status === 'success' && !data?.items.length || status === 'error') {
    return EmptyComponent ? <EmptyComponent /> : <EmptyList />;
  }
  return <div className={s.gridWrapper} data-sentry-component="PaginatedArtistGrid" data-sentry-source-file="PaginatedArtistGrid.tsx">
            <div className={listClassName}>
                <Page showBanners={showBanners} skipFirstBanner={skipFirstBanner} limit={limit} itemsLength={data?.items.length || 0} data-sentry-element="Page" data-sentry-source-file="PaginatedArtistGrid.tsx">
                    {data?.items.map(children)}
                </Page>
            </div>
            
            {data?.totalPages && data.totalPages > 1 && <Pagination currentPage={currentPage} totalPages={data.totalPages} onPageChange={onPageChange} />}
        </div>;
};